import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient, private accountService: AccountService) {}

    getDashboardReport(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/dashboard/getDashboardReport`, {
            params: { branchId: this.accountService.currentUser.branchId },
        });
    }
}
